import { initializeApp } from "firebase/app";
// The lite SDK: this app only ever does one-shot reads and writes, never
// realtime listeners, and lite is roughly a third of the size.
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore/lite";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const useEmulators = import.meta.env.VITE_USE_EMULATORS === "1";

export const app = initializeApp(config);
export const db = getFirestore(app);

if (useEmulators) {
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
}
